module.exports = __webpack_public_path__ + "static/media/n21.56f1534a.jpg";